<template>
    <v-img src="https://parked.blob.core.windows.net/ownli/www/logos/logo.png" v-bind="$attrs" v-if="dark || inverted" />
    <v-img src="https://parked.blob.core.windows.net/ownli/www/logos/logo.png" v-bind="$attrs" v-else/>
</template>

<script>
    import {
        mapGetters
    } from "vuex";

    export default {
        name: "BrandLogo",
        inheritAttrs: false,

        props: {
            inverted: {
                type: Boolean,
                default: false
            },
        },

        computed: {
            ...mapGetters("appshell", ["dark"]),
        },

    }
</script>

<style lang="scss" scoped>
</style>